var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/sidebar-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidebar-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3083 12.4998V7.49984C18.3083 3.33317 16.6416 1.6665 12.4749 1.6665H7.47493C3.30827 1.6665 1.6416 3.33317 1.6416 7.49984V12.4998C1.6416 16.6665 3.30827 18.3332 7.47493 18.3332H12.4749C16.6416 18.3332 18.3083 16.6665 18.3083 12.4998Z",
    stroke: "#292D32",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.6416 1.6665V18.3332",
    stroke: "#292D32",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4751 7.8667L10.3418 10L12.4751 12.1334",
    stroke: "#292D32",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLeft);
export default __webpack_public_path__ + "static/media/sidebar-left.095cba44e59a1d3f9700f6a7b065dd46.svg";
export { ForwardRef as ReactComponent };